export default "__VITE_ASSET__7fec3aa9__"